/* global axios */
import ApiClient from './ApiClient';

const client = new ApiClient('conversations', { accountScoped: true });

/**
 * POST a schedule transition action against a scheduled message.
 *
 *   POST /api/v1/accounts/:account_id/conversations/:conversation_display_id
 *        /messages/:message_id/schedule_action
 * with body { transition_action, action_id, agent_id, edited_text?, reason? }.
 *
 * Note: the body key is `transition_action` (not `action`) because Rails
 * reserves `params[:action]` for the route action name.
 */
export const postScheduleAction = ({
  conversationDisplayId,
  messageId,
  transitionAction,
  actionId,
  agentId,
  editedText,
  reason,
}) => {
  return axios.post(
    `${client.baseUrl()}/conversations/${conversationDisplayId}/messages/${messageId}/schedule_action`,
    {
      transition_action: transitionAction,
      action_id: actionId,
      agent_id: agentId,
      edited_text: editedText,
      reason,
    }
  );
};

export default { postScheduleAction };
